import { Component, Prop, h, State } from '@stencil/core';
import { ConversationalSearchButton } from '../button/button';
import EventEmitterComponent from '../event-emitter-component/event-emitter-component';

@Component({
  tag: 'uiaas-search-widget-conversational-search-suggestion-button',
  styleUrl: 'suggestion-button.scss',
  shadow: true,
})
export class ConversationalSearchSuggestionButton {
  @Prop() readonly data: string[];
  @Prop() readonly query: string;

  @State() isDisabled = false;

  private onAction = () => this.isDisabled = true;

  render() {
      return (
        <section class="conversational-search-suggestion-buttons">
          {this.data?.map((item) => (
            <div class="conversational-search-suggestion-buttons__button">
              <EventEmitterComponent
                eventName='conversational-search:predefined-question'
                query={item}
              >
                <EventEmitterComponent
                  eventName='conversational-search:ga-suggestion'
                  suggestionName={item}
                  keyword={this.query}
                  category='Product Category'
                >
                  <ConversationalSearchButton
                    text={item}
                    onClick={() => this.onAction()}
                    disabled={this.isDisabled}
                  />
                </EventEmitterComponent>
              </EventEmitterComponent>
            </div>
          ))}
        </section>
      );
  }
}